/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TeamManagementFormQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamManagementFormQuery = { staffsByPlanner: Array<{ guid: string, displayName: string }> };


export const TeamManagementFormDocument = gql`
    query TeamManagementForm {
  staffsByPlanner {
    guid
    displayName
  }
}
    `;

/**
 * __useTeamManagementFormQuery__
 *
 * To run a query within a Vue component, call `useTeamManagementFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamManagementFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTeamManagementFormQuery();
 */
export function useTeamManagementFormQuery(options: VueApolloComposable.UseQueryOptions<TeamManagementFormQuery, TeamManagementFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamManagementFormQuery, TeamManagementFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamManagementFormQuery, TeamManagementFormQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TeamManagementFormQuery, TeamManagementFormQueryVariables>(TeamManagementFormDocument, {}, options);
}
export function useTeamManagementFormLazyQuery(options: VueApolloComposable.UseQueryOptions<TeamManagementFormQuery, TeamManagementFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamManagementFormQuery, TeamManagementFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamManagementFormQuery, TeamManagementFormQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TeamManagementFormQuery, TeamManagementFormQueryVariables>(TeamManagementFormDocument, {}, options);
}
export type TeamManagementFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TeamManagementFormQuery, TeamManagementFormQueryVariables>;